import { Address } from '@/modules/accredited-establishments/types/Address'

interface AddressLines {
  street: string
  locality: string
}

/*
 * O cartão da listagem quebra o endereco em duas linhas, cada uma com o proprio
 * truncamento. Por isso as partes saem separadas, e nao numa string unica como
 * em `formatAddress`.
 */
const formatAddressLines = (address?: Address): AddressLines => {
  if (!address) return { street: '', locality: '' }

  const { street, number, complement, neighborhood, city, state, zipcode } =
    address

  return {
    street: [street, number, complement].filter(Boolean).join(', '),
    locality: [
      [neighborhood, `${city}/${state}`].filter(Boolean).join(', '),
      zipcode
    ]
      .filter(Boolean)
      .join(' - ')
  }
}

export { formatAddressLines }
export type { AddressLines }
